// Datos del test astral Ritual (v2). Consumido por rf-quiz.js.
window.RF_QUIZ = {
  "version": 2,
  "preguntas": [
    { "id": "enfoque", "codigo": true, "texto": "¿Qué área de tu vida quieres que tu carta ilumine primero?", "opciones": [
      { "t": "El amor y mis relaciones", "c": "a" },
      { "t": "Mi carrera y el dinero", "c": "c" },
      { "t": "Mi propósito de vida", "c": "p" },
      { "t": "Mi energía y mis emociones", "c": "e" }
    ]},
    { "id": "momento", "codigo": true, "texto": "¿Cómo describirías tu momento actual?", "opciones": [
      { "t": "Estoy iniciando un ciclo nuevo", "c": "1" },
      { "t": "Me siento estancada, algo tiene que cambiar", "c": "2" },
      { "t": "Tengo una decisión importante enfrente", "c": "3" },
      { "t": "Busco claridad, conocerme mejor", "c": "4" }
    ]},
    { "id": "sientes", "codigo": false, "texto": "¿Con cuál frase te identificas más?", "opciones": [
      { "t": "\"Siento que hay algo más para mí que no he encontrado\"" },
      { "t": "\"Repito patrones que no sé de dónde vienen\"" },
      { "t": "\"La gente no me conoce de verdad\"" },
      { "t": "\"Estoy en el lugar correcto, quiero confirmarlo\"" }
    ]},
    { "id": "decisiones", "codigo": false, "texto": "Cuando tomas decisiones importantes, ¿qué pesa más?", "opciones": [
      { "t": "Mi intuición — el cuerpo me habla" },
      { "t": "La lógica — analizo todo" },
      { "t": "Lo que siento por los demás" },
      { "t": "Depende del día (y eso me confunde)" }
    ]},
    { "id": "nivel", "codigo": true, "texto": "¿Qué tanto sabes de astrología?", "opciones": [
      { "t": "Nada, sería mi primera carta", "c": "a" },
      { "t": "Conozco mi signo", "c": "b" },
      { "t": "Conozco mi Sol, Luna y Ascendente", "c": "c" },
      { "t": "Bastante — quiero una lectura seria", "c": "d" }
    ]}
  ],
  "paises": [
    { "cc": "MX", "n": "México" }, { "cc": "US", "n": "Estados Unidos" }, { "cc": "CO", "n": "Colombia" },
    { "cc": "GT", "n": "Guatemala" }, { "cc": "AR", "n": "Argentina" }, { "cc": "ES", "n": "España" },
    { "cc": "PE", "n": "Perú" }, { "cc": "CL", "n": "Chile" }, { "cc": "EC", "n": "Ecuador" },
    { "cc": "VE", "n": "Venezuela" }, { "cc": "BO", "n": "Bolivia" }, { "cc": "HN", "n": "Honduras" },
    { "cc": "SV", "n": "El Salvador" }, { "cc": "NI", "n": "Nicaragua" }, { "cc": "CR", "n": "Costa Rica" },
    { "cc": "PA", "n": "Panamá" }, { "cc": "DO", "n": "República Dominicana" }, { "cc": "PY", "n": "Paraguay" },
    { "cc": "UY", "n": "Uruguay" }, { "cc": "PR", "n": "Puerto Rico" }, { "cc": "OTRO", "n": "Otro país" }
  ],
  "signos": [
    { "n": "Capricornio", "g": "♑︎", "hasta": [1, 19], "d": "constructora, paciente y más sensible de lo que muestras" },
    { "n": "Acuario", "g": "♒︎", "hasta": [2, 18], "d": "mente libre: ves lo que otros todavía no ven" },
    { "n": "Piscis", "g": "♓︎", "hasta": [3, 20], "d": "intuición profunda — sientes la marea antes que nadie" },
    { "n": "Aries", "g": "♈︎", "hasta": [4, 19], "d": "fuego que inicia: donde otros dudan, tú ya empezaste" },
    { "n": "Tauro", "g": "♉︎", "hasta": [5, 20], "d": "presencia y constancia: construyes cosas que duran" },
    { "n": "Géminis", "g": "♊︎", "hasta": [6, 20], "d": "curiosidad infinita — tu mente nunca se aburre" },
    { "n": "Cáncer", "g": "♋︎", "hasta": [7, 22], "d": "memoria emocional honda: cuidas como nadie" },
    { "n": "Leo", "g": "♌︎", "hasta": [8, 22], "d": "corazón que irradia: naciste para ser vista" },
    { "n": "Virgo", "g": "♍︎", "hasta": [9, 22], "d": "ojo preciso: mejoras todo lo que tocas" },
    { "n": "Libra", "g": "♎︎", "hasta": [10, 22], "d": "buscas la armonía y el punto justo de las cosas" },
    { "n": "Escorpio", "g": "♏︎", "hasta": [11, 21], "d": "intensidad transformadora: nada a medias" },
    { "n": "Sagitario", "g": "♐︎", "hasta": [12, 21], "d": "flecha al horizonte: necesitas sentido, no rutina" }
  ]
};
